import makeStyles from '@mui/styles/makeStyles';

const MWIDTH = 320;

const useStyles = makeStyles((theme) => ({
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    width: '100%',
  },
  container: {
    position: 'relative',
    padding: theme.spacing(4),
  },
  fullWidth: {
    width: '100%',
  },
  buttonContainer: {
    maxWidth: 1000,
    margin: '0 auto 10px',
  },
  toggleLabel: {
    top: -21,
    fontSize: 12,
    color: theme.palette.text.primary,
  },
  formStyle: {
    alignItems: 'flex-start !important',
    position: 'relative',
    maxWidth: '1000px !important',
    overflow: 'visible !important',

    '& .inputEach': {
      alignItems: 'flex-start',

      '& .dropZone': {
        position: 'relative',
      },

      '& .dropZone .initialFiles': {
        '& .IMAGE': {
          maxHeight: '100%',
        },
        '&:hover': {
          borderColor: 'inherit !important',
        },
        height: 100,
        backgroundColor: theme.palette.action.disabled,
      },

      '& .dropZone > div:nth-child(2):not(.initialFiles)': {
        border: `1px solid ${theme.colors.inputBorder}`,
        borderRadius: 5,
        height: 100,
        minHeight: 100,

        '& div:first-child': {
          display: 'none',
        },

        '&:hover': {
          borderColor: 'black',
        },

        '& .MuiGrid-container': {
          position: 'absolute',
          top: 0,
          margin: 0,
          width: '100%',
          height: 90,

          '& .MuiGrid-item': {
            padding: 0,
            display: 'block',

            '& img': {
              height: 90,
            },
          },
        },

        '& > div p': {
          fontSize: 10,
        },
      },
    },
    '& .titleContainer': {
      marginBottom: 0,
    },
  },
  titleStyle: {
    fontSize: '16px !important',
    fontWeight: 'bold',
    marginBottom: 0,
  },
  titleContainer: {
    maxWidth: MWIDTH,
    margin: `${theme.spacing(1)} 0`,
    alignSelf: 'flex-start',
  },
  titleRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
  },
  chip: {
    backgroundColor: theme.palette.grey['100'],
    marginRight: 5,
  },
  chipIcon: {
    color: '#57b400',
  },
  screenWidth: {
    width: (props) => (props.isMobile ? '100%' : '90%'),
    boxSizing: 'border-box',
    '& .MuiInput-formControl.Mui-disabled, .MuiInputLabel-formControl, .Mui-disabled': {
      color: theme.palette.text.primary,
    },
    '& .Mui-disabled.MuiInputBase-formControl .MuiSelect-icon': {
      display: 'none',
    },
    '& .Mui-disabled.MuiInput-underline:before': {
      border: `none !important`,
    },
  },
  screenContainer: {
    maxWidth: 400,
    padding: `0 ${theme.spacing(3)}`,
  },
  screenContainerMobile: {
    maxWidth: 'none !important',
  },
  accessContainer: {
    backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    width: 'auto !important',
    '& .MuiFilledInput-root.Mui-disabled.MuiInputBase-formControl': {
      display: 'none',
    },
    '& .Mui-disabled.MuiInput-underline:before': {
      border: `none !important`,
    },
    '& .MuiInput-formControl.Mui-disabled, .MuiInputLabel-formControl, .MuiFormControlLabel-label.Mui-disabled': {
      color: theme.palette.text.primary,
    },
  },
  dropZone: {
    border: `1px solid ${theme.palette.action.disabled} !important`,
    borderRadius: `4px  !important`,
    minHeight: 'auto !important',
    backgroundColor: `${theme.colors.transparent}  !important`,
    '&:hover': {
      border: `1px solid ${theme.palette.text.primary} !important`,
    },
    '& p': {
      fontSize: '14px !important',
      textAlign: 'left !important',
      padding: `${theme.spacing(1)} ${theme.spacing(2)} !important`,
    },
    '& > div > svg': {
      display: 'none !important',
    },
  },
  dropIcon: {
    position: 'absolute',
    right: 9,
    top: 17,
    color: theme.palette.primary.main,
  },
  locRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    fontSize: 13,
  },
  locIcon: {
    marginRight: theme.spacing(1),
  },
  boxContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

export default useStyles;
